import {
  AccountsResponse,
  SettlementSummaryContent,
  SettlementStatus,
} from './accounts.types';

export const formatAccountCurrencyAmount = (amount: number): string => {
  return new Intl.NumberFormat('en', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};

export const formatAccountSummary = (accounts: AccountsResponse[]) => {
  const groupedAccounts = accounts.reduce((acc, account) => {
    const type = account.type.toLowerCase();
    if (!acc[type]) {
      acc[type] = {};
    }
    if (!acc[type][account.currency]) {
      acc[type][account.currency] = 0;
    }
    acc[type][account.currency] += account.balance;
    return acc;
  }, {} as Record<string, Record<string, number>>);

  return {
    payins: Object.entries(groupedAccounts.payins || {}).map(
      ([currency, balance]) => ({
        label: currency,
        value: formatAccountCurrencyAmount(balance),
      }),
    ),
    payouts: Object.entries(groupedAccounts.payouts || {}).map(
      ([currency, balance]) => ({
        label: currency,
        value: formatAccountCurrencyAmount(balance),
      }),
    ),
  };
};

export const getTotalSettledByCurrency = (
  settlements: SettlementSummaryContent[],
): {
  settled: string[];
  completedCount: number;
  pendingCount: number;
} => {
  const totals = settlements.reduce(
    (acc, settlement) => {
      if (settlement.status === SettlementStatus.APPROVED) {
        if (!acc.settled[settlement.currency]) {
          acc.settled[settlement.currency] = 0;
        }
        acc.settled[settlement.currency] += settlement.amount;
        acc.completedCount += 1;
      }

      if (settlement.status === SettlementStatus.CREATED) {
        acc.pendingCount += 1;
      }

      return acc;
    },
    {
      settled: {} as Record<string, number>,
      completedCount: 0,
      pendingCount: 0,
    },
  );

  return {
    settled: Object.entries(totals.settled).map(
      ([currency, amount]) =>
        `${currency} ${formatAccountCurrencyAmount(amount)}`,
    ),
    completedCount: totals.completedCount,
    pendingCount: totals.pendingCount,
  };
};
